<template>
    <div class="chat">
        <CircleWrap @click.native="openChat">
	        <NotificationsCounter v-if="unreadMessages > 0" :count="unreadMessages" />
            <ChatIcon />
        </CircleWrap>
        <Popup mode="chat" :open="open" @closePopup="open = false">
            <!-- HOME -->
            <div v-if="state === 'home'">
	            <ActiveChats v-if="roomCount > 0" />
                <div class="row">
                    <div class="col">
                        <button @click="handleOpenCreate">Ny Chat</button>
                    </div>
                    <div class="col">
                        <button @click="state = 'join'">Deltag</button>
                    </div>
                </div>
            </div>

            <!-- JOIN -->
            <div v-else-if="state === 'join'">
                <div class="back" @click.prevent="handleBack('join')">
                    <BackIcon/>
                </div>
				<JoinChat />
            </div>

            <!-- CREATE -->
            <div v-else-if="state === 'create'">
                <div class="back" @click.prevent="handleBack('create')">
                    <BackIcon/>
                </div>
	            <CreateChat @finishedCreation="handleFinishedCreation" />
            </div>
        </Popup>

        <ChatOverlay v-if="currentRoom !== false" @goBackFromDialog="openChat" @closeDialog="closeRoom" />

    </div>
</template>

<script>
    // Svg
	import User from "@/assets/icons/user.svg"
    import BackIcon from "@/assets/icons/back.svg"

    // Components
	import CircleWrap from "@/components/CircleWrap";
    import ChatIcon from "@/assets/icons/chat.svg"
	import Popup from "@/components/popup/Popup";
    import ChatOverlay from "@/components/chat/ChatOverlay";
    import CreateChat from "@/components/chat/CreateChat";
    import ActiveChats from "@/components/chat/ActiveChats";
    import {mapState} from "vuex";
    import JoinChat from "@/components/chat/JoinChat";
    import NotificationsCounter from "@/components/chat/NotificationsCounter";

	export default {
        data(){
			return{
				open: false,
                state: 'home',
				hasClickedCreate: false
            }
        },
		computed: {
			...mapState('vorbasse', {
				rooms: 'rooms',
				currentRoom: 'currentRoom'
			}),
			roomCount(){
				return Object.keys(this.rooms).length;
			},
			unreadMessages(){
				let count = 0;
				Object.keys(this.rooms).forEach(room => {
					count += Number(this.rooms[room].unreadMessages);
				})
				return count;
			}
		},
        methods: {
	        openChat(){
	        	this.state = 'home';
		        this.open = true
            },
	        closeRoom(){
		        this.$vorbasseSocket.emit('close-room',this.currentRoom.room);
	            this.$store.commit('vorbasse/setCurrentRoom',false);
	        },
	        handleOpenCreate(){
		        this.hasClickedCreate = true;
		        this.state = 'create';
		        setTimeout(() => {
			        this.hasClickedCreate = false;
		        },1000)
	        },
	        handleFinishedCreation(){
	        	this.state = 'home';
	        },
	        handleBack(from){
		        if(!this.hasClickedCreate)
		        {
			        this.state = 'home';
		        }
	        }
        },
		components: {
			NotificationsCounter,
			JoinChat,
			ActiveChats,
			CreateChat,
			ChatOverlay,
			User,
			BackIcon,
			CircleWrap,
			ChatIcon,
			Popup
		},
		watch:{
        	currentRoom(to){
        		if(to !== false){
        			this.open = false;
        			this.state = 'home';
		        }
	        }
		}
	}
</script>

<style lang="scss">
    .chat{
        position: absolute;
        z-index: 15;
        .circle{
            position: fixed;
            bottom: 15px;
            right: 15px;
            svg{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
        }
        h1,h2,h3{
            color: $white;
            margin: 0px 0px 15px;
        }
        p{
            color: $white;
            font-weight: bold;
        }
        .token{
            text-align: center;
            color: $white;
            font-size: 23px;
            font-weight: bold;
            margin-bottom: 50px;
        }
        .alias{
            border: 2px dashed #FFF;
            padding: 10px;
            font-size: 20px;
            font-weight: bold;
            color: #FFF;
            text-align: center;
            margin-top: 10px;
            margin-bottom: 30px;
            position: relative;
            .bubble{
                position: absolute;
                bottom: 65px;
                left: 50%;
                transform: translateX(-50%);
                color: $dark;
            }
        }
        .back{
            position: absolute;
            top: -5px;
            left: -10px;
            width: 43px;
            height: 43px;
            background: $white;
            border-radius: 50%;
            cursor: pointer;
            svg{
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
            }
        }
        ul{
            margin: 0px 0px 35px;
            padding: 0px;
            li{
                display: block;
                list-style: none;
                position: relative;
                margin-bottom: 14px;
                cursor: pointer;
                .text{
                    font-size: 16px;
                    padding: 14px 75px 14px 30px;
                    border: 2px solid $white;
                    color: $white;
                    border-radius: 27px;
                    width: 100%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
                .count{
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 65px;
                    height: 54px;
                    svg{
                        position: absolute;
                        top: 13px;
                        left: 0px;
                    }
                    .amount{
                        position: absolute;
                        top: 0px;
                        left: 35px;
                        line-height: 54px;
                        color: $white;
                    }
                }
            }
        }
    }
</style>
